export const DEFAULT_LOCALE = 'pl'
export const INTERFACE_LOCALES = ['pl', 'en']
export const DEFAULT_INTERFACE_LOCALE = 'en'

export const normalizeLocale = (locale) => {
  if (!locale || typeof locale !== 'string') {
    return null
  }

  return locale.toLowerCase()
}

export const isKnownInterfaceLocale = (locale) => INTERFACE_LOCALES.includes(locale)

export const getInterfaceLocale = (locale) => {
  const normalizedLocale = normalizeLocale(locale)

  return isKnownInterfaceLocale(normalizedLocale) ? normalizedLocale : DEFAULT_INTERFACE_LOCALE
}

export const getRouteLocaleVariant = (locale) => {
  return normalizeLocale(locale) === 'pl' ? 'pl' : 'en'
}

export const isLocaleSegment = (value) => {
  return /^[a-z]{2}(?:-[a-z]{2})?$/i.test(value || '')
}
